import { BaseModel } from '@red/data-access';
import { Expose, Transform, Type } from 'class-transformer';
import { LedgerAccountModel } from './ledger-account.model';
import { UpdatedByModel } from './updated-by.model';

export class ReceiptModeAccountModel extends BaseModel {
  @Expose()
  accountId!: number;

  @Expose()
  accountCode!: string;

  @Expose()
  accountName!: string;

  @Expose()
  sequence!: number;

  @Expose()
  isDefault!: boolean;

  @Expose()
  @Transform(({ obj }) => `${obj.accountCode || ''} ${obj.accountName || ''}`.trim())
  normalizedAccountName!: string;
}

export class ReceiptModeModel extends BaseModel {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  @Type(() => ReceiptModeAccountModel)
  receiptAccounts!: ReceiptModeAccountModel[];

  @Expose()
  @Transform(({ obj }) => {
    if (!obj?.receiptAccounts) return [];
    return obj?.receiptAccounts?.map((r: ReceiptModeAccountModel) => r.accountId);
  })
  receiptAccountIds!: number[];

  @Expose()
  @Transform(({ obj }) => {
    const accountDefault = obj?.receiptAccounts?.find((r: ReceiptModeAccountModel) => r?.isDefault);
    if (!accountDefault) return '';
    return `${accountDefault.accountCode || ''} ${accountDefault.accountName || ''}`.trim();
  })
  receiptAccountDefault!: string;

  @Expose()
  sequence!: number;

  @Expose()
  isDefault!: boolean;

  @Expose()
  isReferenceFieldEnabled!: boolean;

  @Expose()
  referenceLabel!: string;

  @Expose()
  description!: string;

  @Expose()
  status!: string;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  @Type(() => UpdatedByModel)
  updatedBy?: UpdatedByModel;
}
